export const GET_ALL_PROMO_CODES = "GET_ALL_PROMO_CODES";
export const GET_FILTERED_PROMOCODES = "GET_FILTERED_PROMOCODES";
export const DELETE_PROMOCODE = "DELETE_PROMOCODE";
